module.exports = __webpack_public_path__ + "media/images/default/pages/public_science_2/2-a1b7696353eebbec355b7655429fa36a.jpg";